import { createTheme } from '@mui/material/styles';

export const getCustomTheme = (mode) => createTheme({
  palette: {
    mode,
    ...(mode === 'light'
      ? {
          primary: {
            main: '#4F46E5', // Indigo
          },
          secondary: {
            main: '#0EA5E9', // Sky/Cyan
          },
          background: {
            default: '#F8FAFC', // Soft Neutral Gray
            paper: '#FFFFFF',    // White Content Cards
          },
          text: {
            primary: '#0F172A',   // Slate 900
            secondary: '#475569', // Slate 600
          },
        }
      : {
          primary: {
            main: '#818CF8', // Light Indigo
          },
          secondary: {
            main: '#22D3EE', // Cyan/Teal
          },
          background: {
            default: '#080B10', // Deep obsidian dark space
            paper: '#111625',    // Dark card background
          },
          text: {
            primary: '#F8FAFC',   // Slate 50
            secondary: '#94A3B8', // Slate 400
          },
        }),
  },
  typography: {
    fontFamily: '"Plus Jakarta Sans", "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    h1: {
      fontSize: '48px',
      fontWeight: 800,
      fontFamily: '"Outfit", sans-serif',
      letterSpacing: '-0.02em',
    },
    h2: {
      fontSize: '32px',
      fontWeight: 700,
      fontFamily: '"Outfit", sans-serif',
      letterSpacing: '-0.015em',
    },
    h3: {
      fontSize: '28px',
      fontWeight: 700,
      fontFamily: '"Outfit", sans-serif',
      letterSpacing: '-0.01em',
    },
    h4: {
      fontSize: '24px',
      fontWeight: 600,
      fontFamily: '"Outfit", sans-serif',
    },
    h5: {
      fontSize: '20px',
      fontWeight: 600,
      fontFamily: '"Outfit", sans-serif',
    },
    h6: {
      fontSize: '18px',
      fontWeight: 600,
      fontFamily: '"Outfit", sans-serif',
    },
    body1: {
      fontSize: '16px',
      lineHeight: 1.7,
    },
    body2: {
      fontSize: '14px',
      lineHeight: 1.6,
    },
  },
  shape: {
    borderRadius: 16, // Consistent border radius
  },
  components: {
    MuiContainer: {
      styleOverrides: {
        root: {
          maxWidth: '1200px !important',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: '16px', // Slightly larger radius for cards
          backgroundImage: 'none',
          backgroundColor: mode === 'light' ? '#FFFFFF' : 'rgba(17, 22, 37, 0.7)',
          backdropFilter: 'blur(12px)',
          border: mode === 'light' ? '1px solid rgba(0, 0, 0, 0.05)' : '1px solid rgba(255, 255, 255, 0.06)',
          boxShadow: mode === 'light'
            ? '0 1px 3px 0 rgba(0, 0, 0, 0.05), 0 10px 15px -3px rgba(0, 0, 0, 0.02)'
            : '0 4px 30px rgba(0, 0, 0, 0.2)',
          transition: 'transform 0.4s cubic-bezier(0.16, 1, 0.3, 1), box-shadow 0.4s cubic-bezier(0.16, 1, 0.3, 1), border-color 0.4s cubic-bezier(0.16, 1, 0.3, 1)',
          '&:hover': {
            transform: 'translateY(-6px)',
            borderColor: mode === 'light' ? '#4F46E5' : '#818CF8',
            boxShadow: mode === 'light'
              ? '0 10px 25px -5px rgba(79, 70, 229, 0.1), 0 8px 10px -6px rgba(79, 70, 229, 0.05)'
              : '0 10px 25px -5px rgba(129, 140, 248, 0.15), 0 8px 10px -6px rgba(129, 140, 248, 0.08)',
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 600,
          borderRadius: '10px',
          padding: '8px 20px',
          fontFamily: '"Plus Jakarta Sans", sans-serif',
          transition: 'all 0.3s cubic-bezier(0.16, 1, 0.3, 1)',
        },
        containedPrimary: {
          background: mode === 'light'
            ? 'linear-gradient(135deg, #4F46E5 0%, #3B82F6 100%)'
            : 'linear-gradient(135deg, #6366F1 0%, #4F46E5 100%)',
          color: '#FFFFFF',
          boxShadow: mode === 'light'
            ? '0 4px 14px 0 rgba(79, 70, 229, 0.25)'
            : '0 4px 14px 0 rgba(99, 102, 241, 0.35)',
          '&:hover': {
            boxShadow: mode === 'light'
              ? '0 6px 20px 0 rgba(79, 70, 229, 0.35)'
              : '0 6px 20px 0 rgba(99, 102, 241, 0.45)',
            transform: 'translateY(-2px)',
          },
        },
        outlinedPrimary: {
          borderColor: mode === 'light' ? '#4F46E5' : '#818CF8',
          borderWidth: '1.5px',
          '&:hover': {
            borderWidth: '1.5px',
            background: mode === 'light' ? 'rgba(79, 70, 229, 0.04)' : 'rgba(129, 140, 248, 0.08)',
            transform: 'translateY(-2px)',
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
      },
    },
  },
  spacing: 8, // 8px spacing system
});

const defaultTheme = getCustomTheme('light');
export default defaultTheme;

